import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import StatusServices from "./status.services";

export const getStatuss = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_STATUSS,
      payload: true,
    });
    const resp = await StatusServices.getStatuss(filters);
    dispatch({
      type: actions.GET_STATUSS,
      payload: resp.data,
    });
    dispatch({
      type: actions.FAILD_STATUSS,
      payload: null,
    });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FAILD_STATUSS,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.LOADER_STATUSS,
      payload: false,
    });
  }
}

export const getStatus = id => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_STATUS,
      payload: true,
    });
    const resp = await StatusServices.getStatus(id);
    dispatch({
      type: actions.GET_STATUS,
      payload: resp.data,
    });
    dispatch({
      type: actions.FAILD_STATUS,
      payload: null,
    });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FAILD_STATUS,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.LOADER_STATUS,
      payload: false,
    });
  }
}

export const saveStatus = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_STATUS,
      payload: true,
    });
    const resp = await StatusServices.saveStatus(data);
    const { statuss } = getState().sancionesStatus;
    dispatch({
      type: actions.GET_STATUSS,
      payload: {
        count: statuss.count + 1,
        data: [...statuss.data, resp.data]
      },
    });
    dispatch({
      type: actions.FORM_STATUS_FAILD,
      payload: null,
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
    setShowModal(false);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_STATUS_FAILD,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.SAVE_LOADER_STATUS,
      payload: false,
    });
  }
}

export const editStatus = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_STATUS,
      payload: true,
    });
    const resp = await StatusServices.editStatus(id, data);
    const { statuss } = getState().sancionesStatus;
    let _statusData = statuss.data.slice();
    _statusData[index] = resp.data;
    dispatch({
      type: actions.GET_STATUSS,
      payload: {
        count: statuss.count,
        data: _statusData
      },
    });
    dispatch({
      type: actions.FORM_STATUS_FAILD,
      payload: null,
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
    setShowModal(false);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_STATUS_FAILD,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.SAVE_LOADER_STATUS,
      payload: false,
    });
  }
}

export const deleteStatus = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_STATUSS,
      payload: true,
    });
    await StatusServices.deleteStatus(id);
    const { statuss } = getState().sancionesStatus;
    let _statusData = statuss.data.slice();
    _statusData.splice(index, 1);
    dispatch({
      type: actions.GET_STATUSS,
      payload: {
        count: statuss.count -1,
        data: _statusData
      }
    });
    dispatch({
      type: actions.FAILD_STATUSS,
      payload: null,
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FAILD_STATUSS,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.LOADER_STATUSS,
      payload: false,
    });
  }
}